import { type OccasionPreferenceDietaryRestrictions } from '@hungryroot/rest';
import { type Quiz, EatingHabit, Dietary } from '../defs/quiz';

function toSnakeCase(text: string) {
  return text.replace(/-/g, '_').replace(/^[-_]+|[-_]+$/g, '');
}

export function getOccasionPreferenceDietaryRestrictionParamFromQuiz(
  quiz: Quiz
) {
  if (quiz === undefined || quiz.habits === undefined || quiz.habits === null) {
    return;
  }

  const dairyFree =
    quiz.dietary !== null
      ? quiz.dietary.find((dietaryPref) => dietaryPref === Dietary.DairyFree)
      : undefined;
  const dairyFreeParam = dairyFree && toSnakeCase(dairyFree);
  const dietaryRestrictionParam =
    quiz.habits === EatingHabit.Omnivore && dairyFreeParam !== undefined
      ? `is_${quiz.habits},is_${dairyFreeParam}`
      : `is_${quiz.habits}`;

  return dietaryRestrictionParam as OccasionPreferenceDietaryRestrictions;
}
